(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfResumeApplication', [
        'ngDialog',
        'thfValidateItems',
        'MembershipModel',
        function (
            ngDialog,
            thfValidateItems,
            MembershipModel
        ) {

        var link = function(scope, elem) {
            scope.error = {
                show: false,
                title: '',
                message: ''
            };
            scope.modelResume = {};
            scope.fieldResume = {
                email: {
                    'label': 'Email',
                    'labelStyle': '',
                    'name': 'email',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'validation': [
                        'required',
                        'thfEmail'
                    ]
                },
                dateOfBirth: {
                    'label': 'Date of Birth',
                    'labelStyle': '',
                    'name': 'dateOfBirth',
                    'defaultValue': '',
                    'placeholder': 'dd/mm/yyyy',
                    'datePickerOptions': {
                        yearRange: '-110nn:-nn',
                        minDate: moment().month(0).subtract('110', 'years').toDate(),
                        maxDate: moment().toDate()
                    },
                    'tooltip': '',
                    'validation': [
                        'required',
                        'thfDateOfBirth'
                    ]
                },
                /**
                 * Note when changing the options of this
                 * field, you must also update them in the save
                 * application partial.
                 *
                 * Also when removing an item please know that
                 * all applications who used that option will no
                 * longer be able to progress with their application.
                 */
                securityQuestion: {
                    'label': 'Security Question',
                    'labelStyle': '',
                    'name': 'securityQuestion',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'validation': [
                        'required'
                    ],
                    'options': [
                        {value: 'mothers_maiden_name', label: 'What is your mother’s maiden name?'},
                        {value: 'favourite_colour', label: 'What is your favourite colour?'},
                        {value: 'first_pet_name', label: 'What was the name of your first pet?'}
                    ]
                },
                securityAnswer: {
                    'label': 'Security Answer',
                    'labelStyle': '',
                    'name': 'securityAnswer',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'validation': [
                        'required'
                    ]
                }
            };
            scope.validationResume = {};
            scope.formStateResume = {
                tab: 'ResumeModal',
                icon: scope.formState.icon
            };

            scope.onContinue = function( $event, form, data ) {
                $event.preventDefault();
                scope.formState.display.loadingResume = true;
                if( thfValidateItems(scope.fieldResume, scope.modelResume, scope.validationResume, scope.model) ) {
                    scope.error.show = false;

                    DSTAPI.track('event', {
                        category: 'Join Form – Resume Page',
                        action: 'Resume Page - Continue With My Application Clicked',
                        label: 'Resume Page - Continue With My Application Clicked'
                    });

                    var memberPassword = '';
                    memberPassword += scope.modelResume.email+'|';
                    memberPassword += scope.modelResume.dateOfBirth+'|';
                    memberPassword += scope.modelResume.securityQuestion+'|';
                    memberPassword += scope.modelResume.securityAnswer;

                    MembershipModel.get(scope.formState.applicationId, memberPassword).then(
                        function(response){
                            scope.formState.display.loadingResume = false;
                            if( response.result ) {
                                try {
                                    scope.model = scope.modelMigration(JSON.parse(response.content));


                                    scope.ensureCoverStartDateIsCurrent();

                                    scope.detectTabsWithData();

                                    scope.formState.display.form = true;
                                    scope.formState.display.resumeApplication = false;
                                    scope.calculateQuote(function() {
                                        scope.formState.display.quotePanel = true;
                                    });
                                }
                                catch( e ) {
                                    scope.error.show = true;
                                    scope.error.title = 'INVALID DATA';
                                    scope.error.message = 'Please check your details and try again.';
                                }
                            }
                            else {
                                scope.error.show = true;
                                scope.error.title = 'CANNOT ACCESS RECORD';
                                scope.error.message = 'Please check your details and try again.';
                            }
                        },
                        function() {
                            scope.formState.display.loadingResume = false;
                            scope.error.show = true;
                            scope.error.title = 'CANNOT ACCESS RECORD';
                            scope.error.message = 'Please check your details and try again.';
                        });
                }
            };
            
        };
        return {
            'restrict': 'E',
            'replace': true,
            'link': link,
            'templateUrl': function (elem, attr) {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/partials/resume-application.html');
            }
        };
    }]);
})(jQuery, angular, window);
